import { t } from "i18next";

export const externalTooltipHandler = (context: any) => {
  const { chart, tooltip } = context;
  const config = chart.config.options.config;

  let tooltipEl = document.getElementById("chartjs-tooltip");

  if (!tooltipEl) {
    tooltipEl = document.createElement("div");
    tooltipEl.id = "chartjs-tooltip";
    tooltipEl.style.position = "absolute";
    tooltipEl.style.background = "rgb(255, 255, 255)";
    tooltipEl.style.color = "black";
    tooltipEl.style.padding = "6px 10px";
    tooltipEl.style.borderRadius = "4px";
    tooltipEl.style.border = "1px solid #ccc";
    tooltipEl.style.pointerEvents = "none";
    tooltipEl.style.fontSize = "12px";
    tooltipEl.style.fontWeight = "bold";
    tooltipEl.style.zIndex = "999";
    tooltipEl.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.1)";
    document.body.appendChild(tooltipEl);
  }

  // Hide if no tooltip
  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = "0";
    return;
  }

  // Set content
  if (tooltip.body) {
    const lines = tooltip.body.map((b: any, i: number) => {
      const line = b.lines[0] as string;
      const colon = line.indexOf(":");
      const label = colon >= 0 ? line.slice(0, colon) : line;
      const rawValue = colon >= 0 ? line.slice(colon + 1).trim() : "";

      const datasetIndex = tooltip.dataPoints?.[i]?.datasetIndex;
      const dataset =
        datasetIndex !== undefined ? chart.data.datasets[datasetIndex] : undefined;
      const unit =
        (dataset as { unit?: string })?.unit ??
        t("device.units", { context: config?.units });

      const unitKind =
        (dataset as { unitContext?: string })?.unitContext ?? config?.units;

      // Handle array-like string format [min, max]; single-value lines have one number only
      const values = rawValue
        .replace(/[\[\]]/g, "")
        .split(",")
        .map((v: string) => parseFloat(v.trim()))
        .filter((n: number) => Number.isFinite(n));

      switch (unitKind) {
        case "level":
        case "temperature":
        case "humidity":
          if (values.length >= 2) {
            const average = (values[0] + values[1]) / 2;
            return `${label}:<br>Avg: ${average.toFixed(2)} ${unit}<br>Min: ${values[0].toFixed(2)} ${unit}<br>Max: ${values[1].toFixed(2)} ${unit}`;
          }
          if (values.length === 1) {
            return `${label}: ${values[0].toFixed(2)} ${unit}`;
          }
          return `${label}: ${rawValue} ${unit}`;
        default:
          return `${label}: ${values.length ? values.join(", ") : rawValue} ${unit}`;
      }
    });
    tooltipEl.innerHTML = lines.join("<br>");
  }

  const { canvas } = chart;
  const rect = canvas.getBoundingClientRect();

  tooltipEl.style.opacity = "1";
  tooltipEl.style.left = `${rect.left + window.pageXOffset + tooltip.caretX}px`;
  tooltipEl.style.top = `${rect.top + window.pageYOffset + tooltip.caretY}px`;
};